import { useMediaQuery } from '@vueuse/core';

/** True below Tailwind's `md` breakpoint — keep in sync with `screens.md`. */
export function useIsMobile() {
    return useMediaQuery('(max-width: 767px)');
}
